/* @ngInject */
const updateAllAxletreesModal = (
  $uibModal,
  saleRequest,
  toaster,
  types,
) => {
  const self = {}

  self.open = (_sale) => {
    return $uibModal.open({
      template: require('./updateAllAxletrees.html'),
      resolve: {
        sale: () => {
          return _sale
        },
      },
      /* @ngInject */
      controller: ($scope, $uibModalInstance, sale) => {
        $scope.model = ''
        $scope.options = {
          label: 'Poids des essieux',
          icon: 'train',
          type: types.decimal,
          required: true,
        }

        $scope.submit = async () => {
          try {
            const response = await saleRequest.updateAllAxletrees(sale.id, $scope.model)
            toaster.message(response.message, response.color)
            sale.wagons = response.sale.wagons
            $uibModalInstance.close()
          } catch (error) {
            toaster.error(error)
            $uibModalInstance.close()
          }
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default updateAllAxletreesModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/modals/updateAllAxletrees.modal.js